module.exports = __webpack_public_path__ + "static/media/adm.d8324b84.svg";